/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description React Hook useGetPaymentAllocation
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import QUERY_KEYS from 'app-constants/queryKeys';
import api from 'client/index';

/**
 * useGetPaymentAllocation
 * @returns {UseQueryResult} usePaymentSubmissions
 */
const useGetPaymentAllocation = (id: string, options?: IQueryOptions): UseQueryResult<PatientPayment.IPaymentReconciliation, unknown> => {
	return useQuery({
		queryKey: [QUERY_KEYS.paymentAllocation, { id }],
		queryFn: async () => {
			const { data } = await api.PaymentReconciliationApi.getPaymentReconciliation({
				paymentReconciliationId: id,
			});
			return data;
		},
		enabled: !!id,
		...options,
	});
};

export default useGetPaymentAllocation;
